import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'hubs.admissions.contact.title',
    defaultMessage: `Admissions`,
  },
  hint: {
    id: 'hubs.admissions.contact.hint',
    defaultMessage: `Get in touch with the admissions office at {schoolName}`,
  },
  attn: {
    id: 'hubs.admissions.contact.attn',
    defaultMessage: `Attn: {attn}`,
  },
  phone: {
    id: 'hubs.admissions.contact.phone',
    defaultMessage: `Phone: {phone}`,
  },
  fax: {
    id: 'hubs.admissions.contact.fax',
    defaultMessage: `Fax: {fax}`,
  },
  financial_aid: {
    id: 'hubs.admissions.contact.financial_aid',
    defaultMessage: `Financial Aid: {financialAid}`,
  },
  email: {
    id: 'hubs.admissions.contact.email',
    defaultMessage: `E-mail: {email}`,
  },
  footer: {
    id: 'hubs.admissions.contact.footer',
    defaultMessage: `Latest available data from {lastUpdatedYear}`,
  },
});

export default messages;
